import { client } from './client'
import Person from '../models/person'

export default {
  index (query) {
    return client.get('/persons', {
      params: query
    })
  },
  show (id) {
    return client.get('/persons/' + id)
      .then((response) => {
        return new Person(response.data.data)
      })
  },
  store (data) {
    return client.post('/persons', data.prepareForSend())
  },
  update (id, data) {
    return client.patch('/persons/' + id, data.prepareForSend())
  },
  search (data, query) {
    return client.get('/persons', {
      params: {
        filter: JSON.stringify(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    })
  },
  select (data) {
    let person = new Person()
    person.nome = data
    return client.get('/persons', {
      params: {
        filter: JSON.stringify(person),
        limit: 100,
        orderBy: 'nome'
      }
    })
  },
  delete (id) {
    return client.delete('/persons/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/persons.js